import PropTypes from 'prop-types';
import React from 'react';

import { sanitizeRichText } from '../../../utils/reRenderFormulas';

function RichText({ html = '', tag: Tag = 'div', className = '', ...rest }) {
  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: sanitizeRichText(html) }}
      {...rest}
    />
  );
}

RichText.propTypes = {
  html: PropTypes.string,
  tag: PropTypes.string,
  className: PropTypes.string,
};

export default RichText;
